module.exports = "{% extends 'base.html.twig' %}\n\n{% block title %}{{movie.name}}{% endblock %}\n\n{% block body %}\n    <div class=\"movie\">\n        <h2>{{ movie.name }}</h2>\n        <p>{{ movie.director }}</p>\n        <p>{{ movie.year }}</p>\n        <div class=\"actors\">\n            {% for actor in movie.actors %}\n                <div>{{ actor.name}}</div>\n            {% else %}\n                This movie has no actors.\n            {% endfor %}\n        </div>\n    </div>\n{% endblock %}"


//////////////////
// WEBPACK FOOTER
// ./~/raw-loader!./src/pages/code/template-movie-1.txt
// module id = 659
// module chunks = 166022795811749